import { TApplicationState } from 'shared/types/redux';

export const selectFormLeadId = (state: TApplicationState): string | undefined => {
  return state.formStatus.leadId;
};
